import { AbstractResource } from "./AbstractResource";

export class Templates extends AbstractResource {
    async getBydId(templateId) {
        const { data } = await this.http.get(`/template/${templateId}`);
        return data;
    }

    async saveConfig(templateId, dto) {
        if (dto.id) {
            const { data } = await this.http.put(`/template/${templateId}/configuration/${dto.id}`, dto);
            return data;
        } else {
            const { data } = await this.http.post(`/template/${templateId}/configuration`, dto);
            return data;
        }
    }

    async getConfig(templateId, configId) {
        const { data } = await this.http.get(`/template/${templateId}/configuration/${configId}`);
        return data;
    }
}